import React from 'react';

const ExternalLink = (props: React.AnchorHTMLAttributes<HTMLAnchorElement>) => {
  return <a className="text-primary" rel="noopener noreferrer" target="_blank" {...props} />;
};

export default ExternalLink;
